import { useState } from "react"
import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"
import TenantCreateDialog from "@/v2-backoffice-client/tenant/create/TenantCreateDialog"
import { useAppViewSheetOpener } from "@/v2-backoffice-client/app/app.utils"

export type TenantCreateButtonProps = ButtonProps

function TenantCreateButton(props: TenantCreateButtonProps) {
  const { onClick, children, ...buttonProps } = props
  const [isOpen, setIsOpen] = useState(false)
  const opener = useAppViewSheetOpener()

  return (
    <>
      <Button
        variant="primary"
        size="tiny"
        iconSrc="plus"
        iconSize={10}
        onClick={(e) => {
          setIsOpen(true)
          onClick?.(e)
        }}
        {...buttonProps}
      >
        {children ?? "Add team"}
      </Button>

      <TenantCreateDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        onCreated={(tenant) => {
          if (opener.kind) return
          opener.open("tenant", tenant.Id)
        }}
      />
    </>
  )
}

export default TenantCreateButton
